import * as React from "react";
const ChevronUp = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M11.8833796,8.18133292 L11.8872867,8.18433292 L11.8900332,8.1824613 L12.5971399,8.88956809 L12.5942867,8.89133292 L18.9617796,15.2535291 L18.2546728,15.9606359 L11.8862867,9.59933292 L5.52539349,15.9606359 L4.81828671,15.2535291 L11.1792867,8.89233292 L11.1762728,8.8884397 L11.8833796,8.18133292 Z" }));
ChevronUp.displayName = "ChevronUp";
var ChevronUp_default = ChevronUp;
export {
  ChevronUp_default as default
};
